<template></template>
<script>
  export default {
    name: 'Auth',
    data() {
      return {
        token: localStorage.getItem('WBToken'),
        userId: localStorage.getItem('userId'),
      }
    },
    created() {
      window.addEventListener('message', this.logout);

      if (!this.token) {
        window.parent.postMessage({message: 'login'}, '*');
      } else {
        window.parent.postMessage({message: 'loaded'}, '*');

        // Set event listener for 'update-token' message request
        window.addEventListener('message', this.sendToken);
      }
    },
    methods: {
      sendToken(event) {
        if (event.data && event.data.message === 'update-token') {
          const message = {
            message: 'token-to-update',
            token: this.token,
            userId: this.userId,
            remember: true
          };

          window.parent.postMessage(message, '*');
        }
      },
      logout(event) {
        if (event.data && event.data.message === 'logout') {
          localStorage.removeItem('WBToken');
          localStorage.removeItem('userId');

          this.$store.dispatch('logout');

          window.parent.postMessage({message: 'loggedOut'}, '*');
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Auth.vue?d9fc98ae